import React from "react";
import Select from "react-select";
import { deepEqual } from "../../../utils/object";

export const GenerationsData = [
  { value: "", label: "N/A" },
  { value: "Sr", label: "Sr." },
  { value: "Jr", label: "Jr." },
  { value: "III", label: "III" },
  { value: "IV", label: "IV" },
  { value: "V", label: "V" },
  { value: "VI", label: "VI" },
  { value: "VII", label: "VII" },
  { value: "VIII", label: "VIII" },
];

export function exists(value) {
  return GenerationsData.some((obj) => obj.value === value);
}

const findOption = (value) =>
  GenerationsData.find((opt) => opt.value === (value ?? "")) || GenerationsData[0];

class GenerationsSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.mapPropsToState(props);
  }

  mapPropsToState = (props) => ({
    value: props.value ?? "",
  });

  componentDidUpdate(prevProps) {
    const oldSlice = this.mapPropsToState(prevProps);
    const newSlice = this.mapPropsToState(this.props);

    if (deepEqual(oldSlice, newSlice)) return;

    // Guard against redundant setState loops
    if (this.state.value === newSlice.value) return;

    this.setState(newSlice);
  }

  onChange = (opt) => {
    const nextValue = opt?.value ?? "";
    if (this.state.value === nextValue) return;

    this.setState({ value: nextValue }, () => {
      // Call prop handler (not this.state.onChange)
      this.props.onChange?.({ value: nextValue, label: opt?.label ?? nextValue });
    });
  };

  render() {
    const selected = findOption(this.state.value);

    return (
      <Select
        id={this.props.id}
        value={selected}                 // single option object
        className={this.props.className}
        name={this.props.name}
        onChange={this.onChange}
        classNamePrefix="react-select"
        placeholder={this.props.placeholder ?? ""}
        options={GenerationsData}
        isClearable={this.props.isClearable ?? false}
      />
    );
  }
}

export default GenerationsSelect;